module.exports = __webpack_public_path__ + "img/google.4fa3edb5.svg";